export var NavigationEvent;
(function (NavigationEvent) {
    NavigationEvent[NavigationEvent["PREV"] = 0] = "PREV";
    NavigationEvent[NavigationEvent["NEXT"] = 1] = "NEXT";
})(NavigationEvent || (NavigationEvent = {}));
//# sourceMappingURL=datepicker-view-model.js.map


//////////////////
// WEBPACK FOOTER
// /Users/alexandre/Documents/web/riberfuso/resources/ng/~/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-view-model.js
// module id = ../../../../@ng-bootstrap/ng-bootstrap/datepicker/datepicker-view-model.js
// module chunks = 9